import React, { useContext } from "react";
import { AuthContext } from "@context/AuthContext";
import { BookSessionContext } from "@context/BookSessionContext.js";
import Drawer from "@components/V3/Drawer";
import VoucherSummary from "@components/VoucherManager/VoucherSummary";

const VoucherCheckoutDrawer = ({ type }) => {
    const { drawerState, closeDrawer } = useContext(AuthContext);
    const { selectedItems, setTermsAccepted } = useContext(BookSessionContext);

    return (
        <>
            <Drawer
                id="voucher-checkout-drawer"
                role="dialog"
                aria-modal="true"
                aria-label="Voucher Checkout Drawer"
                isOpen={drawerState.voucherCheckoutDrawer}
                showBackdrop={false}
                onClose={() => {
                   setTermsAccepted(false);
                   closeDrawer("voucherCheckoutDrawer");}
                }
                closeButtonAlignment="right"
            >
                <VoucherSummary
                    items={selectedItems}
                    type={type}
                 />
            </Drawer>
        </>
    );
};

export default VoucherCheckoutDrawer;
